import axios from 'axios';

// http://10.17.4.150
// https://api.mv3.com.br
// http://localhost:8009

export const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'https://mv3-supplychain-api.ldspartners.com.br',
    timeout: 9999999
});
